import { ExpressionRule } from "../../ExpressionRule";
import { IDataDefinition } from "../../../Common/Data/Definitions/IDataDefinition";
import { DateDataDefinition } from "../../../Common/Data/Definitions/DateDataDefinition";

export abstract class BaseDateExpression extends ExpressionRule {
    protected _expressionValueType: IDataDefinition = new DateDataDefinition();

    get expressionValueType(): IDataDefinition {
        return this._expressionValueType;
    }

    set expressionValueType(expressionValueType: IDataDefinition) {
        this._expressionValueType = expressionValueType;
    }
}
